<h2 mat-dialog-title>{{ isEdit ? 'Edit Contact' : 'Add Contact' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="br-flex br-flex-column br-gap-2 br-mt-1">

    <!-- Name row: firstName + lastName side-by-side -->
    <div class="br-flex br-gap-3">
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" maxlength="64">
        <mat-error *ngIf="form.get('firstName')?.hasError('required')">Required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" maxlength="64">
        <mat-error *ngIf="form.get('lastName')?.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Display Name</mat-label>
      <input matInput formControlName="displayName" maxlength="128">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phone" maxlength="32">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" maxlength="128" type="email">
      <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" maxlength="64">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Role</mat-label>
      <mat-select formControlName="contactRole">
        <mat-option *ngFor="let r of contactRoles" [value]="r">{{ r }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="notes" rows="3" maxlength="2000"></textarea>
    </mat-form-field>

    <mat-slide-toggle formControlName="isPrimary">Primary Contact</mat-slide-toggle>

    <div *ngIf="formError" class="br-small br-text-danger br-mt-1">
      {{ formError }}
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="br-gap-2">
  <button type="button" class="br-btn br-btn--outline-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" (click)="submit()"
          [disabled]="form.invalid || saving">
    Save
  </button>
</mat-dialog-actions>
